import type { DisciplineInfo } from '@brighterly/lib-core-types/discipline/interfaces'

import { useCsRoutes } from '@shared/api'

import { useKidStore } from '../model/kid-store/store'

interface ActiveKidApiOptions {
  onStart?: () => void
  onSuccess?: (disciplines: DisciplineInfo[]) => void
  onError?: (err: any) => void
  onFinish?: () => void
}

export const useActiveKidDisciplinesApi = async (kidId: number, options?: ActiveKidApiOptions): Promise<DisciplineInfo[] | null> => {
  const { $axios } = useNuxtApp()

  const kidStore = useKidStore()

  const url = useCsRoutes('kid', {
    '[kid_id]': kidId,
  })

  const mode = kidStore.getDisciplinesStatus(kidId) === 'ready' ? 'refresh' : 'enter'
  const requestId = kidStore.beginDisciplines(kidId, mode)
  options?.onStart?.()

  try {
    const { data } = await $axios.get(url!)
    const disciplines: DisciplineInfo[] = data.data || []

    kidStore.settleDisciplines(kidId, requestId, disciplines)
    options?.onSuccess?.(disciplines)

    return disciplines
  } catch (err: any) {
    console.error(err)

    kidStore.failDisciplines(kidId, requestId)
    options?.onError?.(err)

    return null
  } finally {
    options?.onFinish?.()
  }
}
